"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFormattedSuggestionArray = exports.isFormattedSuggestion = void 0;
const Util_1 = require("./Util");
const TypeaheadCategory_1 = require("./TypeaheadCategory");
const isValidCategory = (val) => (0, TypeaheadCategory_1.isValidTypeaheadCategoryV8)(val) || (0, TypeaheadCategory_1.isValidTypeaheadCategory)(val);
const lookup = {
    highlight: Util_1.isString,
    name: Util_1.isString,
    category: isValidCategory,
    categoryDisplayText: Util_1.isString,
    queryString: Util_1.isString
};
const isFormattedSuggestion = (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
target) => {
    try {
        return Object.entries(lookup).every(([key, test]) => {
            // the target must have an entry for every required key in our lookup validator
            // object and each entry in the target has to pass the approriate test. optional
            // keys, if defined, must pass the appropriate test
            switch (key) {
                case 'highlight': {
                    return !target[key] || test(target[key]);
                }
                default: {
                    return target[key] && test(target[key]);
                }
            }
        });
    }
    catch (e) {
        return false;
    }
};
exports.isFormattedSuggestion = isFormattedSuggestion;
exports.isFormattedSuggestionArray = (0, Util_1.predicateArrayOn)(exports.isFormattedSuggestion);
//# sourceMappingURL=FormattedSuggestion.js.map